<template>
    <div>
        <label><input type="checkbox" v-model="relatedToMe"/> Related to me</label>

        <highcharts
            v-if="loaded"
            :options="getOptions(chartOptions)"
            ref="chart"
        />

        <div v-else class="d-flex justify-content-center">
            <b-spinner :style="{'color':constants.spinnerColor}"></b-spinner>
        </div>

        <StartupsModal
            ref="startupsModal"
            :filters="filters"
            @startupRemovedFromTracker="fetchChartData"
        />

        <TrackersListModal
            ref="trackersListModal"
            :read-only="true"
        />
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from "highcharts/modules/exporting"
    import dashboardChartMixin from '@/mixins/dashboardChartMixin'
    import string from "@/helpers/string";
    import TrackersListModal from "@/components/trackers/TrackersListModal.vue";
    import dashboardService from "@/services/dashboard.service";
    import StartupsModal from "@/components/charts/StartupsModal.vue";

    typeof exportingInit === 'function' && exportingInit(Highcharts);

    export default {
        name: 'RequestsByBusinessArea',
        mixins: [dashboardChartMixin],
        components: {
            StartupsModal,
            TrackersListModal,
            highcharts: Chart
        },

        provide() {
            return {
                getTrackersIndexList: (pageParams) => dashboardService.getChartTrackersList(this.chartName, this.filters, this.code, pageParams)
            }
        },

        data() {
            return {
                loaded: false,
                relatedToMe: false,
                chartName: "RequestsByBusinessArea",
                chartOptions: {
                    chart: {
                        type: 'column'
                    },

                    title: {
                        text: 'Requests and PoCs overview',
                        align: 'left'
                    },

                    xAxis: {
                        labels: {
                            style: {
                                fontWeight: 'bold',
                                fontSize: '13px'
                            }
                        },
                        tickWidth: 0,
                        lineWidth: 0,
                        crosshair: true
                    },

                    yAxis: {
                        allowDecimals: false,
                        min: 0,
                        title: {
                            text: 'Number of Projects'
                        }
                    },

                    tooltip: {
                        formatter: function() {
                            const isActive = this.series.name.includes('Active');
                            const status = isActive ? 'Active' : 'Closed';
                            const businessArea = this.series.name.replace(';Active', '').replace(';Closed', '');
                            return `<b>${businessArea}</b><br>` +
                                `${this.x} - ${status}: ${this.y} ${string.getNoun('project', this.y)}`;
                        }
                    },

                    plotOptions: {
                        column: {
                            stacking: 'normal',
                            groupPadding: 0.15,   // Space between project type groups
                            pointPadding: 0.1     // Space between Active/Closed pairs
                        },
                        series: {
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    // Only show totals for the last series in each stack
                                    if (this.point.stackTotal && this.point.y && this.point.stackY === this.point.stackTotal) {
                                        return this.point.stackTotal;
                                    }
                                    return '';
                                },
                                style: {
                                    fontWeight: 'bold',
                                    color: 'black'
                                },
                                y: -40
                            }
                        }
                    },

                    series: [],
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal',
                        itemMarginBottom: 5
                    }
                },

                code: [],
            }
        },
        watch: {
            relatedToMe() {
                this.filters.relatedToMe = this.relatedToMe;
                this.fetchChartData()
            },
        },
        methods: {
            fetchChartData(initialCall = false) {
                this.getChartData('RequestsByBusinessArea').then(response => {
                    let data = response.data

                    this.chartOptions.series = data.series.map(item => ({
                        ...item,
                        events: {
                            click: (e) => {
                                this.openStartupsModal(e.point.category, item.name)
                            }
                        }
                    }));

                    this.chartOptions.xAxis.categories = data.categories;

                    if (!initialCall) {
                        this.$refs.chart.chart.hideLoading()
                    } else {
                        this.loaded = true
                    }
                })
            },

            openStartupsModal(category, name) {
                if (['Problem Statement', 'Opportunity Statement'].includes(category)) {
                    this.code = [category, name, this.relatedToMe];
                    this.$refs.trackersListModal.open(true);
                } else {
                    this.$refs.startupsModal.open(this.chartName, `Startups - ${category} - ${name}`, JSON.stringify([category, name, this.relatedToMe]));
                }
            }
        }
    }
</script>
